import { DeleteButton } from "@common/components/Button";
import Grid from "@mui/material/Grid2";
import { useErrorNotification } from "@common/components/Notification";
import ToolButtonsContainer from "@common/components/ToolButtonsContainer";
import { Add, Replay } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import { deleteRoles } from "@services/user";
import { Role as RoleType } from "@services/user/types";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Role from "../Role";

type MainBarProps = {
  selected: RoleType["id"][];
  fetch: Function;
  canEdit?: boolean;
};

const MainBar = (props: MainBarProps) => {
  const { selected, fetch, canEdit } = props;
  const dispatchError = useErrorNotification();
  const { t } = useTranslation();

  const [addOpen, setAddOpen] = useState(false);

  const onRoleClose = async () => {
    setAddOpen(false);
    await fetch();
  };

  const confirmDelete = async () => {
    try {
      await deleteRoles(selected);
      await fetch();
    } catch (e) {
      dispatchError(e);
    }
  };

  const count = selected.length;

  return (
    <Grid
      container
      sx={{ width: '100%', alignItems: "center",
        justifyContent: "end", }}
    >
      {canEdit && (
        <ToolButtonsContainer>
          <Tooltip title={t("Add")} arrow>
            <span>
              <IconButton onClick={() => setAddOpen(true)}>
                <Add />
              </IconButton>
            </span>
          </Tooltip>
        </ToolButtonsContainer>
      )}
      <Role open={addOpen} onClose={onRoleClose} />
      <ToolButtonsContainer>
        <DeleteButton
          disabled={!canEdit}
          count={count}
          label={t(`Delete {{count}} role${count === 1 ? "" : "s"}`, {
            count,
          })}
          onClick={() => confirmDelete()}
          withConfirm
          ConfirmDialogProps={{
            actionLabel: t(`Delete Role${count === 1 ? "" : "s"}`),
            confirmPrompt: t(
              count === 1
                ? "Are you sure you want to delete this role?"
                : "Are you sure you want to delete {{count}} roles?",
              { count }
            ),
          }}
        />
      </ToolButtonsContainer>
      <ToolButtonsContainer>
        <Tooltip title={t("Refresh") as string} arrow>
          <span>
            <IconButton onClick={async () => await fetch()}>
              <Replay />
            </IconButton>
          </span>
        </Tooltip>
      </ToolButtonsContainer>
    </Grid>
  );
};

export default MainBar;
